import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'Como funciona o BEN+?',
      answer: 'O BEN+ é um pacote de benefícios completo que oferece 8 serviços essenciais por apenas R$ 59,90/mês. Após o primeiro pagamento, você e até 4 dependentes têm acesso imediato a telemedicina 24h, descontos em farmácias, indenizações, assistências e muito mais.'
    },
    {
      question: 'Quantas pessoas podem ser cobertas?',
      answer: 'Depende do benefício. Telemedicina, descontos em farmácia e desconto em consultas cobrem o titular + 4 dependentes. Já as indenizações por morte e invalidez, auxílio funeral e algumas assistências são exclusivas do titular. Confira os detalhes de cada benefício para mais informações.'
    },
    {
      question: 'A ativação é imediata?',
      answer: 'Sim! Após a confirmação do primeiro pagamento, a maioria dos benefícios é ativada imediatamente. Você pode usar a telemedicina, descontos em farmácia e assistências assim que sua adesão for confirmada.'
    },
    {
      question: 'Como funciona a telemedicina?',
      answer: 'A telemedicina oferece pronto atendimento 24 horas por dia, 7 dias por semana. Você pode agendar consultas com especialistas através do aplicativo ou central de atendimento. O serviço está disponível para o titular e até 4 dependentes.'
    },
    {
      question: 'Posso cancelar a qualquer momento?',
      answer: 'Sim, você tem total liberdade para cancelar o plano quando quiser, sem taxas de cancelamento ou multas. Basta entrar em contato através do nosso WhatsApp.'
    },
    {
      question: 'Como funcionam os descontos em farmácia?',
      answer: 'Você tem acesso a descontos de 10% a 70% em medicamentos em uma ampla rede de farmácias credenciadas. Através do aplicativo, você pode pesquisar medicamentos e encontrar as farmácias com os melhores preços próximas de você.'
    },
    {
      question: 'As indenizações têm carência?',
      answer: 'As indenizações por morte e invalidez são válidas a partir do primeiro pagamento, conforme as condições contratuais. Recomendamos consultar os termos completos para entender todas as coberturas e exclusões.'
    },
    {
      question: 'Como faço para contratar?',
      answer: 'É muito simples! Clique no botão "Contratar pelo WhatsApp" e nossa equipe irá te guiar por todo o processo de adesão. Em poucos minutos você estará protegido.'
    }
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-600">
            Tire suas dúvidas sobre o BEN+
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gray-50 rounded-xl px-6 border-2 border-gray-100 hover:border-[#00E5CC]/50 transition-colors duration-300"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-[#00E5CC] py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center bg-[#00E5CC]/10 rounded-2xl p-8 border-2 border-[#00E5CC]/20">
          <p className="text-lg text-gray-900 mb-2">
            Ainda tem dúvidas?
          </p>
          <p className="text-gray-600 mb-3">
            Entre em contato pelo WhatsApp:{' '}
            <a
              href="https://wa.me/5511961475604?text=Olá! Gostaria de saber mais sobre o BEN+ALLCRED"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#00E5CC] hover:text-[#00D4BE] transition-colors"
            >
              (11) 96147-5604
            </a>
          </p>
          <p className="text-gray-600">
            Ou acesse:{' '}
            <a
              href="https://sistema.benmais.com/auto-contratacao?ref=MWZkYjg4ZDEtYzdiOC00ZTZiLWEzZDAtMGE5YjlkMjQ5ZTBhOmJiOGZmOTBiLWM5NjYtNDVmZi05MzAwLTUwNTkwMzhjYTczMQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#00E5CC] hover:text-[#00D4BE] transition-colors"
            >
              Sistema de Contratação
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};
